export const getVerifiedUser = 'getVerifiedUser';
